import { render } from "./PaymentMethodSelector.vue?vue&type=template&id=efcbd364&scoped=true&ts=true"
import script from "./PaymentMethodSelector.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodSelector.vue?vue&type=script&lang=ts"

import "./PaymentMethodSelector.vue?vue&type=style&index=0&id=efcbd364&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efcbd364"]])

export default __exports__